export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'After a long run, the last thing I wanted was a blank page. The incident narrative prompts give me a clean, chronological starting draft from my own notes. I still review everything against our SOPs, but I wrap up my documentation much faster at the end of shift.',
    name: 'Firefighter Mark T.',
    location: 'Chicago, IL · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ebe52574-185d-4126-88a9-e99502104ce3.jpg',
  },
  {
    quote:
      'I help organize drills at our station and the Training Planner changed how I prepare. Objectives, scenario outlines and evaluation checklists come together in one go, then I adapt them to our standards. The equipment checklists are a great bonus too.',
    name: 'Firefighter Sophia L.',
    location: 'London, UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ce06b607-208b-41c8-90ce-a87d327f1f42.jpg',
  },
  {
    quote:
      "As a captain, admin work piles up fast: shift summaries, memos, meeting agendas. These prompts fit right into my weekly routine. They're practical, easy to customize, and they keep the human review where it belongs.",
    name: 'Captain David P.',
    location: 'Toronto, Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/39943045-3190-46f8-bd63-9860b0a7cfc5.jpg',
  },
];
